import { all, call, put, takeLatest } from "redux-saga/effects";
import { GET_LIST_HOPDONGCHODUYET } from "../actions/DanhSachHopDongChoDuyet/actionTypes";
import {
  getListHopDongChoDuyetSuccess,
  getListHopDongChoDuyetFailure,
} from "../actions/DanhSachHopDongChoDuyet";
import DanhSachHopDongChoDuyetApi from "../service/danhSachHopDongChoDuyetApi";

function* getListHopDongChoDuyet(action) {
  try {
    const response = yield call(
      DanhSachHopDongChoDuyetApi.GetDanhSachHopDongChoDuyet,
      action.dataSearch
    );
    if (response.ok) {
      yield put(getListHopDongChoDuyetSuccess(response.data));
    } else {
      yield put(getListHopDongChoDuyetFailure());
    }
  } catch (error) {
    yield put(getListHopDongChoDuyetFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_LIST_HOPDONGCHODUYET, getListHopDongChoDuyet);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
